import React from 'react';
import PropTypes from 'prop-types';
import { URLS } from 'consts';
import Badge from 'components/ui/Badge';
import Flex from 'components/ui/Flex';

const ProjectTitle = ({ onProjectView, project }) => {
  const showBadges =
    project.activated_recently || project.updated_recently || project.is_match;
  return (
    <div className="mb-4">
      <div className="font-base font-bold d-flex flex-wrap">
        <a
          className="unstyled mr-2"
          href={URLS.project(project.slug)}
          onClick={onProjectView}
        >
          {project.project_title}
        </a>
        {showBadges && (
          <Flex gap={5}>
            {(project.activated_recently || project.updated_recently) && (
              <Badge>{project.activated_recently ? 'New' : 'Updated'}</Badge>
            )}
            {project.is_match && (
              <Badge color="primary" variant="outlined">
                Recommended
              </Badge>
            )}
          </Flex>
        )}
      </div>
      <div className="d-flex">
        {project.company_name && (
          <>
            <div className="text-primary-blue font-sm mr-2">
              {project.company_name}
            </div>
            {project.industry_name && <div className="mr-2">•</div>}
          </>
        )}
        {project.industry_name && (
          <div className="font-sm text-alt">{project.industry_name}</div>
        )}
      </div>
    </div>
  );
};

ProjectTitle.propTypes = {
  onProjectView: PropTypes.func,
  project: PropTypes.object,
};

export default ProjectTitle;
